// tiptap用の有料会員限定エリア表示用の拡張機能

import { Node } from "@tiptap/core";

export interface MemberOnlyOptions {
  HTMLAttributes: {
    [key: string]: any;
  };
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    memberOnly: {
      /**
       * Add an memberOnly
       */
      setMemberOnly: () => ReturnType;
    };
  }
}

export default Node.create<MemberOnlyOptions>({
  name: "memberOnly",

  group: "block",
  content: "block*",

  draggable: true,

  "data-drag-handle": true,

  atom: true,

  addOptions() {
    return {
      HTMLAttributes: {
        class: "member-only-wrapper",
      },
    };
  },

  addAttributes() {
    return {};
  },

  parseHTML() {
    return [
      {
        tag: "memberonly",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["memberOnly", HTMLAttributes];
  },

  renderText() {
    return "renderText";
  },

  addCommands() {
    return {
      setMemberOnly:
        () =>
        ({ tr, dispatch }) => {
          const { selection } = tr;
          const node = this.type.create();

          if (dispatch) {
            tr.replaceRangeWith(selection.from, selection.to, node);
          }

          return true;
        },
    };
  },

  addNodeView() {
    return ({ editor }) => {
      const {
        options: { editable },
      } = editor;
      const $element = document.createElement("memberonly");

      if (!editable) return { dom: $element };

      const $container = document.createElement("div");
      // divにhr-with-textを追加
      $container.classList.add("hr-with-text");
      $container.classList.add("cursor-pointer");
      $container.appendChild($element);
      // 有料エリアのspanを追加
      const $span = document.createElement("span");
      $span.textContent = "この先は会員限定です";
      $container.appendChild($span);

      return {
        dom: $container,
      };
    };
  },
});
